// Official Top Player Sportswear logo (owner-supplied, extracted from PDF).
// light=false → dark artwork for light backgrounds; light=true → white artwork for navy.
export default function Logo({ light = false, className = "h-14" }) {
  return (
    <img
      src={light ? "/logo-light.png" : "/logo-dark.png"}
      alt="Top Player Sportswear"
      data-testid="site-logo"
      className={`${className} w-auto object-contain`}
    />
  );
}
